import { LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { DatePipe } from '@angular/common'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LoginComponent } from './ui/pages/login/login.component'
import { DashboardComponent } from './ui/pages/dashboard/dashboard.component'
import { NavbarComponent } from './ui/components/navbar/navbar.component'
import { SideNavTogglerComponent } from './ui/components/side-nav-toggler/side-nav-toggler.component'
import { SideNavComponent } from './ui/components/side-nav/side-nav.component'
import { MatMenuModule } from '@angular/material/menu'
import { PageHeaderComponent } from './ui/components/page-header/page-header.component'
import { AuthGuardService } from './core/services/util/role-guard.service'
import { HomePageComponent } from './ui/pages/home-page/home-page.component'
import { IngresosPageComponent } from './ui/pages/ingresos-page/ingresos-page.component'
import { EgresosComponent } from './ui/pages/egresos/egresos.component'
import { HttpClientModule } from '@angular/common/http'
import { CookieService } from 'ngx-cookie-service'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AddDialogComponent } from './ui/components/dialogs/add-dialog/add-dialog.component'
import { authInterceptorProviders } from './core/services/api/helpers/http-interceptor'
import { CategoriesComponent } from './ui/pages/categories/categories.component'
import { SubcategoriesComponent } from './ui/pages/subcategories/subcategories.component'
import { AddSubcategoryComponent } from './ui/components/dialogs/add-subcategory/add-subcategory.component'

/*Material imports*/
import { MatIconModule } from '@angular/material/icon'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatDialogModule } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatSelectModule } from '@angular/material/select'
import { AddRecordComponent } from './ui/components/dialogs/add-record/add-record.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { MatCardModule } from '@angular/material/card'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { DailyCutComponent } from './ui/pages/reports/daily-cut/daily-cut.component'
import { MensualBalanceComponent } from './ui/pages/reports/mensual-balance/mensual-balance.component'
import { ServicesComponent } from './ui/pages/reports/services/services.component'
import { CashFlowComponent } from './ui/pages/reports/cash-flow/cash-flow.component'
import { MomentDateModule } from '@angular/material-moment-adapter'
import { CashFlowSimpleComponent } from './ui/pages/reports/cash-flow-simple/cash-flow-simple.component'
import { PettyComponent } from './ui/pages/petty/petty.component'
import { AddPettyComponent } from './ui/components/dialogs/add-petty/add-petty.component'
import { registerLocaleData } from '@angular/common'

import localeEs from '@angular/common/locales/es'
import { MonthPickerComponent } from './ui/components/month-picker/month-picker.component'
import { TicketComponent } from './ui/components/util/ticket/ticket.component'
import { LocationsComponent } from './ui/pages/locations/locations.component'
import { AddLocationComponent } from './ui/components/dialogs/add-location/add-location.component'
registerLocaleData(localeEs, 'es')

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DashboardComponent,
        NavbarComponent,
        SideNavTogglerComponent,
        SideNavComponent,
        PageHeaderComponent,
        HomePageComponent,
        IngresosPageComponent,
        EgresosComponent,
        AddDialogComponent,
        CategoriesComponent,
        SubcategoriesComponent,
        AddSubcategoryComponent,
        AddRecordComponent,
        DailyCutComponent,
        CashFlowComponent,
        MensualBalanceComponent,
        ServicesComponent,
        CashFlowSimpleComponent,
        PettyComponent,
        AddPettyComponent,
        MonthPickerComponent,
        TicketComponent,
        LocationsComponent,
        AddLocationComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatCheckboxModule,
        MatMenuModule,
        MatTableModule,
        MatPaginatorModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatButtonModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatCardModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatExpansionModule,
    ],
    providers: [
        AuthGuardService,
        CookieService,
        MomentDateModule,
        authInterceptorProviders,
        DatePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-GB' },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
